import { memo, useCallback } from 'react';

import { styled } from '@mui/material';

import { colors } from '~/styles/constants';

interface RowProps {
  asGrid?: boolean;
  clickable?: boolean;
  isSelected?: boolean;
  ref?: React.RefObject<HTMLTableRowElement>;
}

const Row = styled('tr')<RowProps>(({ asGrid, clickable, isSelected, theme }) => ({
  ...(clickable && { cursor: 'pointer' }),
  borderBottom: `1px solid ${colors.gray50}`,
  ...(isSelected && { backgroundColor: theme.palette.success.light }),
  ':hover': {
    backgroundColor: theme.palette.success.light,
  },
  'thead > &:hover': {
    backgroundColor: 'white',
  },
  ...(asGrid && {
    ':hover > td': {
      backgroundColor: theme.palette.success.light,
    },
    '> td': {
      borderBottom: `1px solid ${colors.gray50}`,
    },
    '> th': {
      borderBottom: `1px solid ${colors.gray50}`,
    },
    display: 'contents',
  }),
}));

interface TableRowProps {
  asGrid?: boolean;
  children?: React.ReactNode;
  dataPendo?: string;
  forwardRef?: React.RefObject<HTMLTableRowElement>;
  isSelected?: boolean;
  onClick?: (rowIndex: number) => void;
  rowIndex?: number;
}

const TableRow = memo((props: TableRowProps) => {
  const { asGrid, children, dataPendo, forwardRef, isSelected, onClick, rowIndex } = props;

  const onClickCallback = useCallback(() => {
    if (onClick) return onClick(rowIndex || 0);
  }, [onClick, rowIndex]);

  return (
    <Row
      asGrid={asGrid}
      clickable={!!onClick}
      data-pendo={dataPendo}
      isSelected={isSelected}
      onClick={onClickCallback}
      ref={forwardRef}
    >
      {children}
    </Row>
  );
});

export const MessageRow = styled(Row)`
  color: #95a3b7;
  background-color: #f1f6fa;
  text-align: center;
`;

export default TableRow;
